import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useParams } from "react-router";

import { getAllMasters } from "../../store/actions/MasterActions";
import { AppDispatch, RootState } from "../../store";
import classes from "./Home.module.css";
import {
  getPODData,
  getPODDisclaimers,
  getPODInfoQuestions,
} from "../../store/actions/PODActions";

const Home: React.FC<{}> = () => {
  const dispatch: AppDispatch = useDispatch();
  const { pathname } = useLocation();
  const { podId } = useParams();
  const { pod } = useSelector((state: RootState) => state.pod);

  useEffect(() => {
    dispatch(getAllMasters());
  }, [dispatch]);

  useEffect(() => {
    if (podId) dispatch(getPODData(podId));
  }, [podId]);

  useEffect(() => {
    if (pod.disclaimers?.length) {
      dispatch(getPODDisclaimers(pod.disclaimers));
    }
    if (pod.infoQuestions?.length) {
      dispatch(getPODInfoQuestions(pod.infoQuestions));
    }
  }, [pod]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={classes.main}>
      <Outlet />
    </div>
  );
};

export default Home;
